import * as React from "react";
import { useState } from "react";
import classNames from "classnames";
import { UnmountClosed } from "react-collapse";
import { ModelPortfolioTabType } from "../../../../../Wrap/Constants/Enums/Domain/ModelPortfolioTabType";
import { InstrumentSearchQuery } from "../../../../../Wrap/Models/Domains/Investment/InstrumentSearchQuery";
import { InvestmentSelectionAction } from "../../Action/InvestmentSelectionAction";
import { AutoComplete } from "./AutoComplete";
import { RestrictionStore } from "../../../../Dashboard/Components/Clients/Common/Restrictions/Variable";
import { ResearchISTDispatcher } from "../../../../Dashboard/Components/ToolsAndLiterature/Store/Variable";
import { ActionType } from "../../../../../react-core/Flux/ActionType";

interface IAdvancedSearchProps {
    hiercharyId: string;
    query: InstrumentSearchQuery;
    children?: any;
    placeholder?: string;
    modelPortfolioType?: ModelPortfolioTabType;
    index?: number;
    cssWrapper?: string;
    showResult?: any;
    forceAdvanced?: boolean;
    showAutoComplete?: boolean;
}

export const AdvancedSearch = (props: IAdvancedSearchProps) => {
    const { 
        hiercharyId, 
        query, 
        children, 
        placeholder, 
        modelPortfolioType, 
        index, 
        cssWrapper, 
        showResult, 
        forceAdvanced = false,
        showAutoComplete = true
    } = props;

    const [showAdvanced, setShowAdvanced] = useState(false);

    const cssWrapperClass = classNames("advanced-search", props.cssWrapper);

    const AdvancedToggle = () => {
        setShowAdvanced(!showAdvanced);
    };

    return (
        <>
            <div className={cssWrapperClass}>
                {showAutoComplete && (
                    <>
                    <AutoComplete
                        placeholder={props.placeholder || "Search"}
                        label="Search"
                        query={props.query}
                        hiercharyId={props.hiercharyId}
                        onSelected={(investment) => {
                            ResearchISTDispatcher.dispatch({ actionType: ActionType.Update, payload: null });
                            if (props.showResult && props.showResult.current) {props.showResult.current.close();}
                            InvestmentSelectionAction.addInvestment(investment, props.modelPortfolioType);
                            if (props.index) {InvestmentSelectionAction.setEditingTransferNumber(props.index);}
                        }}
                        onLookupError={() => {}}
                        cssWrapper="label-sr-only submit-is-magnifier-glass mb-0"
                        disabled={RestrictionStore.buyDisabled()}
                    />
                    <button
                        className="ist-advanced-toggle"
                        type="button"
                        onClick={() => AdvancedToggle()}
                        aria-expanded={showAdvanced}
                    >
                        {showAdvanced ? "Basic search" : "Advanced search"}
                    </button>
                    </>
                )}
                <UnmountClosed isOpened={props.forceAdvanced || showAdvanced}>{props.children}</UnmountClosed>
            </div>
        </>
    );
};
